import { thumbHashBase64ToDataURL } from "@/lib/thumbhash";
import { cn } from "@/lib/utils";
import { type ReactNode, useMemo, useState } from "react";

interface ProgressiveImageProps {
  imageHash?: string;
  className?: string;
  placeholderClassName?: string;
  children: (props: { loaded: boolean; onLoad: () => void }) => ReactNode;
}

export function ProgressiveImage({
  imageHash,
  className,
  placeholderClassName,
  children,
}: Readonly<ProgressiveImageProps>) {
  const [loaded, setLoaded] = useState(false);

  const placeholder = useMemo(() => {
    if (!imageHash) return undefined;

    return thumbHashBase64ToDataURL(imageHash);
  }, [imageHash]);

  return (
    <div className={className}>
      {placeholder && (
        <img
          src={placeholder}
          aria-hidden
          alt=""
          className={cn(
            "absolute size-full",
            loaded ? "opacity-0" : "opacity-100",
            placeholderClassName,
          )}
        />
      )}

      {children({
        loaded,
        onLoad: () => setLoaded(true),
      })}
    </div>
  );
}
